import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { CountryRegionsConfigResponse } from "@warrenio/api-spec/spec.oats.gen";

const queryKey: QueryKey = ["billing_country_region_config"];

function getRegionsConfigQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<CountryRegionsConfigResponse> =>
            getResponseData(await client.GET("/payment/config/country_regions", { signal })),
    });
}

export const countryRegionsConfigQueryAtom = atomFromStandardQueryOptions(getRegionsConfigQuery);
